<div [formGroup]="form">
  <div class="id-type">
    <mat-button-toggle-group
      name="idType"
      aria-label="Type de justificatif d'identité"
      class="id-type-toggle"
      exclusive
      [value]="idType"
    >
      <mat-button-toggle value="identityDocument" (change)="onIdTypeChange($event.value)">
        Pièce d'identité
      </mat-button-toggle>
      <mat-button-toggle value="residentPermit" (change)="onIdTypeChange($event.value)">
        Titre de séjour
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="id-documents">
    <div class="resident-permit-documents w-100 wrap">
      <app-document-form
        formControlName="identityDocument"
        tag="identityDocument"
        [required]="validation() && idType === 'identityDocument'"
        (uploaded)="uploaded.emit($event)"
      ></app-document-form>
    </div>
    <div class="resident-permit-documents w-100 wrap">
      <app-document-form
        formControlName="residentPermit"
        tag="residentPermit"
        [readOnly]="readOnly()"
        [required]="validation() && idType === 'residentPermit'"
        (uploaded)="uploaded.emit($event)"
      ></app-document-form>
      <mat-form-field class="w-100 date-field">
        <mat-label>Date d'expiration</mat-label>
        <input
          matInput
          [matDatepicker]="residentPermitExpirationDatePicker"
          [formControl]="form.controls.residentPermitExpirationDate"
          [required]="validation() && idType === 'residentPermit'"
        />
        <mat-datepicker-toggle
          matIconPrefix
          [for]="residentPermitExpirationDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #residentPermitExpirationDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="residence-type">
    <mat-button-toggle-group
      name="residenceType"
      aria-label="Type de justificatif de résidence"
      class="residence-type-toggle"
      exclusive
      [value]="residenceType"
    >
      <mat-button-toggle value="proofOfResidence" (change)="onResidenceTypeChange($event.value)"
        >Justificatif de domicile</mat-button-toggle
      >
      <mat-button-toggle value="proofOfAccommodation" (change)="onResidenceTypeChange($event.value)"
        >Attestation d'hébergement</mat-button-toggle
      >
    </mat-button-toggle-group>
  </div>

  <div class="residence-documents">
    <app-document-form
      formControlName="proofOfResidence"
      tag="proofOfResidence"
      [required]="validation() && residenceType === 'proofOfResidence'"
      (uploaded)="uploaded.emit($event)"
      class="w-100"
    ></app-document-form>

    <div class="host-documents w-100">
      <app-document-form
        formControlName="proofOfAccommodation"
        tag="proofOfAccommodation"
        [required]="validation() && residenceType === 'proofOfAccommodation'"
        (uploaded)="uploaded.emit($event)"
      ></app-document-form>
      <app-document-form
        formControlName="hostIdentityDocument"
        tag="hostIdentityDocument"
        [required]="validation() && residenceType === 'proofOfAccommodation'"
        (uploaded)="uploaded.emit($event)"
      ></app-document-form>
      <app-document-form
        formControlName="hostProofOfResidence"
        tag="hostProofOfResidence"
        [required]="validation() && residenceType === 'proofOfAccommodation'"
        (uploaded)="uploaded.emit($event)"
      ></app-document-form>
    </div>
  </div>

  <app-document-form
    formControlName="rib"
    tag="rib"
    (uploaded)="uploaded.emit($event)"
  ></app-document-form>
  <app-document-form
    formControlName="socialSecurityCertificate"
    tag="socialSecurityCertificate"
    (uploaded)="uploaded.emit($event)"
  ></app-document-form>

  <div class="flex gap w-100 wrap driving-license">
    <app-document-form
      formControlName="drivingLicense"
      tag="drivingLicense"
      [required]="validation() && companyCar()"
      (uploaded)="uploaded.emit($event)"
    ></app-document-form>
    <mat-form-field class="w-100 date-field">
      <mat-label>Date d'expiration</mat-label>
      <input
        matInput
        [matDatepicker]="drivingLicenseExpirationDatePicker"
        [formControl]="form.controls.drivingLicenseExpirationDate"
      />
      <mat-datepicker-toggle
        matIconPrefix
        [for]="drivingLicenseExpirationDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #drivingLicenseExpirationDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
